module.exports = __webpack_public_path__ + "static/media/nu.b05a321b.svg";